import React from 'react'

import { TCommentThreadData } from 'types/GlobalComment'

import { useCommentActions } from 'redux/actions/Comments'
import { useCommentThreads } from 'redux/hooks/Comments'
import { useKeyMetric } from 'redux/hooks/KeyMetrics'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

import CommentThreads from 'components_new/molecules/CommentThreads'

interface KeyMetricSidebarProps {
  focusedCommentThreadId: string | null
  id: string
  newCommentThread: TCommentThreadData | null
  setFocusedCommentThreadId: React.Dispatch<React.SetStateAction<string | null>>
  setNewCommentThread: React.Dispatch<
    React.SetStateAction<TCommentThreadData | null>
  >
}

const KeyMetricSidebar = (props: KeyMetricSidebarProps) => {
  const {
    focusedCommentThreadId,
    id,
    newCommentThread,
    setFocusedCommentThreadId,
    setNewCommentThread
  } = props

  const keyMetric = useKeyMetric(id)

  const commentThreads = useCommentThreads(keyMetric?.id)
  const { tryCreateComment } = useCommentActions()

  // loading
  if (!keyMetric)
    return (
      <>
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} height={96} variant="rounded" />
        ))}
      </>
    )

  // success
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: 1,
        minHeight: 0,
        overflowY: 'auto'
      }}
    >
      <CommentThreads
        commentThreads={commentThreads}
        focusedCommentThreadId={focusedCommentThreadId}
        keyMetricId={keyMetric.id}
        newCommentThread={newCommentThread}
        onCreateComment={tryCreateComment}
        setFocusedCommentThreadId={setFocusedCommentThreadId}
        setNewCommentThread={setNewCommentThread}
      />
    </Box>
  )
}

export default KeyMetricSidebar
